module.exports = __webpack_public_path__ + "img/qrcode1.e6e55ad7.png";